import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) => state.internalIdLogin || initialState;

export const selectInternalIdLogin = createSelector(
  [selectSlice],
  state => state,
);
export const selectInternalIdLoginUserId = createSelector(
  [selectInternalIdLogin],
  state => state.identity?.Id,
);
export const selectInternalIdLoginUserName = createSelector(
  [selectInternalIdLogin],
  state => state.identity?.Name,
);
export const selectLoginType = createSelector(
  [selectSlice],
  state => state.identity?.LoginType,
);
